import * as React from "react";
import "./AgencyLoginScreen.css";
import { isLoading, Loading } from "../Loading";
import { GenericTextInput } from "./inputs/GenericTextInput";
import { HRQuestionId } from "../messages/ObjectIds";
import { Intent, Spinner } from "@blueprintjs/core";

interface AgencyLoginScreenProps {
    onSubmitClick: (email: string, password: string) => void;
    showLoginError: string | null | Loading;
}

interface AgencyLoginScreenState {
    email: string;
    password: string;
    secretCounter: number;
    secret: string;
}

export class AgencyLoginScreen extends React.Component<AgencyLoginScreenProps, AgencyLoginScreenState> {
    constructor(props: AgencyLoginScreenProps) {
        super(props);
        this.state = {
            email: "",
            password: "",
            secretCounter: 0,
            secret: ""
        };
    }

    handleSubmitClick = () => {
        const email = this.state.email;
        const password = this.state.password;
        if (email.length < 5 || email.indexOf("@") === -1 || email.indexOf(".") === -1) {
            // todo
        } else {
            this.props.onSubmitClick(email, password);
        }
    }

    handleChange(newVal: string, id: string) {
        this.setState((prevState) => {
            // TODO this is shit for time reasons
            let email = prevState.email;
            let pass = prevState.password;
            if (id === "AgencyMemberEmail") {
                email = newVal;
            } else {
                pass = newVal;
            }
            return {
                password: pass,
                email: email
            };
        });
    }

    handleSecretChange(newVal: string) {
        this.setState({ secret: newVal });
    }

    handleSecretSubmitClick = () => {
        localStorage.setItem("code", this.state.secret);
    }

    throwTestCrash = () => {
        throw new Error("Sentry test crash!");
    }

    incSecretCounter = () => {
        this.setState(prevState => {
            return {
                secretCounter: prevState.secretCounter + 1
            };
        });
    }

    render() {
        return (
            <div className={"AgencyLoginScreen__root"}>
                <h1 onClick={this.throwTestCrash}>Welcome to MedFlyt HR!</h1>
                <h4 className={"text-secondary mb-0"} onClick={this.incSecretCounter}>First you'll need to login</h4>
                <div className="control-group">
                    <label className={"AgencyLoginScreen__label"}>Email</label>
                    <input
                        required={true}
                        className={"form-control"}
                        onChange={(e) => this.handleChange(e.target.value, "AgencyMemberEmail")}
                        placeholder={"example@medflyt.com"}
                        value={this.state.email === null ? "" : this.state.email}
                        type="email"
                    />
                </div>
                <div className="control-group">
                    <label>Password</label>
                    <input
                        required={true}
                        className={"form-control"}
                        onChange={(e) => this.handleChange(e.target.value, "AgencyMemberPassword")}
                        placeholder={"Password"}
                        value={this.state.password === null ? "" : this.state.password}
                        type="password"
                    />
                </div>

                {isLoading(this.props.showLoginError) ?
                    <Spinner intent={Intent.PRIMARY}/>
                    :
                    <button
                        type={"submit"}
                        onClick={this.handleSubmitClick}
                        className="AgencyLoginScreen__submit btn btn-primary btn-xl"
                    >
                        Login
                    </button>
                }
                <div className={"help-block text-danger"}>{isLoading(this.props.showLoginError) ? null : this.props.showLoginError}</div>
                {this.state.secretCounter < 6 ? null :
                    <div>
                        <input
                            required={true}
                            className={"form-control"}
                            onChange={(e) => this.handleSecretChange(e.target.value)}
                            placeholder={"Password"}
                            value={this.state.secret}
                            type="password"
                        />
                        <button
                            type={"submit"}
                            onClick={this.handleSecretSubmitClick}
                            className="AgencyLoginScreen__submit btn btn-primary btn-xl"
                        >
                            Login
                        </button>
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AgencyLoginScreen.tsx